import * as actionTypes from '../actions/types';

const initialState = {
    idPresentacion: null,
    datosPrestadores: [],
    tipoComprobantes: [],
    tipoPrestaciones: [],
    tipoPresentaciones: [],
    codigosComprobante: [],
    letraComprobante: '',
    tipoPrestacionSeleccionada: '',
    prestadorSeleccionado: null,
    pathTemporal: null,
    tipoComprobantesSeleccionado: '',
    codigoComprobanteSeleccioado: '',
    tipoPresentacionSeleccionada: '',
    emailResponsable: '',
    telefonoResponsable: '',
    estado: {},
    nroFactura: '',
    fechaEmisionComp: null,
    nroReferencia: '',
    facturaFile: [],
    imagenesFiles: [],
    idComprobante: [],
    liquidacionesFiles: [],
    internaciones: [],
    prestaciones: [],
    estaVinculada: false,
    esEdicion: false,
    submitValido: false,
    soloVista: false,
    requeridos: {
        codPrestador: { requerido: true, esValido: false },
        emailContacto: { requerido: true, esValido: false },
        telefonoContacto: { requerido: true, esValido: false },
        tipoPresentacion: { requerido: true, esValido: false },
        tipoPrestacion: { requerido: false, esValido: false },
        tipoComprobante: { requerido: false, esValido: false },
        codComprobante: { requerido: false, esValido: false },
        nroComprobante: { requerido: false, esValido: false },
        fechaEmisionComp: { requerido: false, esValido: false },
        facturas: { requerido: false, esValido: false },
        imagenes: { requerido: false, esValido: false },
        liquidaciones: { requerido: false, esValido: false },
        prestaciones: { requerido: false, esValido: false },
        internaciones: { requerido: false, esValido: false },
    },
    errorMensaje: {},
    mostrarBackdrop: false,
    mostrarNuevaInternacion: false,
    comentario: null,
};

export function nuevaPresentacionReducer(state = initialState, action) {
    const _internaciones = [...state.internaciones];

    switch (action.type) {
        case actionTypes.ACTUALIZAR_ATRIBUTO_PRESENTACION:
            return {
                ...state,
                ...action.payload,
            };
        case actionTypes.INICIALIZAR_NUEVA_PRESENTACION:
            return {
                ...state,
                ...initialState,
                requeridos: {
                    codPrestador: { ...initialState.requeridos.codPrestador },
                    emailContacto: { ...initialState.requeridos.emailContacto },
                    telefonoContacto: {
                        ...initialState.requeridos.telefonoContacto,
                    },
                    tipoPresentacion: {
                        ...initialState.requeridos.tipoPresentacion,
                    },
                    tipoPrestacion: {
                        ...initialState.requeridos.tipoPrestacion,
                    },
                    tipoComprobante: {
                        ...initialState.requeridos.tipoComprobante,
                    },
                    codComprobante: {
                        ...initialState.requeridos.codComprobante,
                    },
                    nroComprobante: {
                        ...initialState.requeridos.nroComprobante,
                    },
                    fechaEmisionComp: {
                        ...initialState.requeridos.fechaEmisionComp,
                    },
                    facturas: { ...initialState.requeridos.facturas },
                    imagenes: { ...initialState.requeridos.imagenes },
                    liquidaciones: { ...initialState.requeridos.liquidaciones },
                    prestaciones: { ...initialState.requeridos.prestaciones },
                    internaciones: { ...initialState.requeridos.internaciones },
                },
            };
        case actionTypes.ACTUALIZAR_FACTURA_FILE:
            return {
                ...state,
                facturaFile: [...action.payload],
            };
        case actionTypes.ACTUALIZAR_IMAGENES_FILES:
            return {
                ...state,
                imagenesFiles: [...action.payload],
            };
        case actionTypes.ACTUALIZAR_PRESTACIONES_FILES:
            return {
                ...state,
                prestaciones: [...action.payload],
            };
        case actionTypes.ACTUALIZAR_LIQUIDACIONES_FILES:
            return {
                ...state,
                liquidacionesFiles: [...action.payload],
            };
        case actionTypes.ACTUALIZAR_INTERNACIONES:
            return {
                ...state,
                internaciones: [...action.payload],
            };
        case actionTypes.AGREGAR_INTERNACION:
            return {
                ...state,
                internaciones: _internaciones.concat([{ ...action.payload }]),
            };

        case actionTypes.ACTUALIZAR_NRO_INTERNACION:
            _internaciones[action.payload.index].nroInternacion = parseInt(
                action.payload.nroInternacion
            );

            return {
                ...state,
                internaciones: _internaciones,
            };
        case actionTypes.ACTUALIZAR_INFO_NRO_INTERNACION:
            _internaciones[action.payload.index].nombreCompleto =
                action.payload.nombreCompleto;
            if (action.payload.nroDocumento !== null){
                _internaciones[action.payload.index].nroDocumento =
                action.payload.nroDocumento;
            }
            _internaciones[action.payload.index].nroSocio =
                action.payload.nroSocio;
            return {
                ...state,
                internaciones: _internaciones,
            };
        case actionTypes.ACTUALIZAR_INTERNACION:
            const internacionActualizada = { ...action.payload };

            const aux = _internaciones.map((el) => {
                if (
                    (internacionActualizada.id &&
                        internacionActualizada.id === el.id) ||
                    (internacionActualizada.tempId &&
                        internacionActualizada.tempId === el.tempId)
                ) {
                    return internacionActualizada;
                }
                return el;
            });

            return {
                ...state,
                internaciones: aux,
            };
        case actionTypes.CARGAR_DATOS_PRESENTACION:
            const prestador = {
                codPrestador: action.payload.codPrestador,
                razonSocial: action.payload.razonSocial,
                tipoPresentacion: action.payload.tipoPresentacion.id,
            };
            const _comprobantes = action.payload.comprobantes;

            const _tipoFactura =
                _comprobantes.length > 0
                    ? action.payload.comprobantes[0].tipoComprobante.id
                    : '';

            const comprobante = state.tipoComprobantes.filter(
                (elemento) => elemento.id === _tipoFactura
            )[0];

            const _nroComprobante =
                _comprobantes.length > 0
                    ? action.payload.comprobantes[0].nroComprobante
                    : '';
            
            const _fechaEmisionComp =
            _comprobantes.length > 0
                ? action.payload.comprobantes[0].fechaEmisionComp
                : '';

            const _letraComprobante =
                _comprobantes.length > 0
                    ? action.payload.comprobantes[0].tipoComprobanteCodigo.letra
                    : '';

            const _codigoComprobanteSeleccioado =
                _comprobantes.length > 0
                    ? action.payload.comprobantes[0].tipoComprobanteCodigo.id
                    : '';

            const _tipoPrestacionSeleccionada =
                _comprobantes.length > 0
                    ? action.payload.comprobantes[0].tipoPrestacion.id
                    : '';
            const _idTipoPresentacion = action.payload.tipoPresentacion.id;
            const _nroReferencia = 
                _comprobantes.length > 0
                    ? action.payload.comprobantes[0].nroReferencia
                    : '';
            const _facturasFile =
                _comprobantes.length > 0
                ? action.payload.comprobantes[0].detalles
                : [];

            const _idComprobante = 
                _comprobantes.length > 0
                    ? action.payload.comprobantes[0].id
                    : '';
            return {
                ...state,
                mostrarNuevaInternacion: false,
                prestadorSeleccionado: prestador,
                tipoComprobantesSeleccionado: _tipoFactura,
                emailResponsable: action.payload.contactoEmail,
                telefonoResponsable: action.payload.contactoTelefono,
                nroFactura: _nroComprobante,
                fechaEmisionComp: _fechaEmisionComp,
                nroReferencia: _nroReferencia,
                idComprobante: _idComprobante,
                facturaFile: _facturasFile,
                imagenesFiles: action.payload.imagenes,
                liquidacionesFiles: action.payload.liquidaciones,
                internaciones: _idTipoPresentacion===3? (function(){
                    action.payload.internacionesSocios.forEach(i => {
                        i.nroInternacion = i.nroDocumento;
                    })
                    return action.payload.internacionesSocios}()
                ) : (action.payload.internaciones),
                prestaciones: action.payload.prestaciones,
                estaVinculada: action.payload.nroRecepcion ? true : false,
                codigoComprobanteSeleccioado: _codigoComprobanteSeleccioado,
                tipoPrestacionSeleccionada: _tipoPrestacionSeleccionada,
                tipoPresentacionSeleccionada: _idTipoPresentacion,
                codigosComprobante: comprobante ? comprobante.codigos : [],
                letraComprobante: _letraComprobante,
                estado: { ...action.payload.estado },
                comentario: action.payload.comentario,
                requeridos: {
                    codPrestador: { requerido: true, esValido: true },
                    emailContacto: { requerido: true, esValido: true },
                    telefonoContacto: { requerido: true, esValido: true },
                    tipoPresentacion: { requerido: true, esValido: true },
                    tipoPrestacion: {
                        requerido: _comprobantes.length > 0,
                        esValido: _comprobantes.length > 0,
                    },
                    tipoComprobante: {
                        requerido: _comprobantes.length > 0,
                        esValido: _comprobantes.length > 0,
                    },
                    codComprobante: {
                        requerido: _comprobantes.length > 0,
                        esValido: _comprobantes.length > 0,
                    },
                    nroComprobante: {
                        requerido: _comprobantes.length > 0,
                        esValido: _comprobantes.length > 0,
                    },
                    fechaEmisionComp: {
                        requerido: _comprobantes.length > 0,
                        esValido: _comprobantes.length > 0,
                    },
                    facturas: {
                        requerido: _comprobantes.length > 0,
                        esValido: _comprobantes.length > 0,
                    },
                    imagenes: {
                    requerido: _idTipoPresentacion  === 3,
                        esValido: action.payload.imagenes.length > 0,
                    },
                    liquidaciones: {
                        requerido: action.payload.liquidaciones.length > 0 && _idTipoPresentacion  === 1,
                        esValido: action.payload.liquidaciones.length > 0,
                    },
                    prestaciones: {
                        requerido: action.payload.prestaciones.length > 0,
                        esValido: action.payload.prestaciones.length > 0,
                    },
                    internaciones: {
                        requerido: _tipoPrestacionSeleccionada === 2,
                        esValido: action.payload.internaciones.length > 0,
                    },
                },
            };
        default:
            return state;
    }
}
